export default "__VITE_ASSET__ec731180__"